import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk } from ".";
import {
  GET_REPORTS_ANALYTICS_PRODUCTS,
  GET_REPORTS_ANALYTICS_STOCK_INFO,
  REPORTS_ANALYTICS_ORDER,
} from "../../utils/queries";

export const reportsAnalyticsOrderThunk = createAsyncThunk(
  "reportsAnalyticsOrderSlice/reportsAnalyticsOrderThunk",
  createGraphQLThunk({
    query: REPORTS_ANALYTICS_ORDER,
    getVariables: ({ orderRequestFilters }) => ({ orderRequestFilters }),
    responseKey: "getOrderCounters",
    url: process.env.REACT_APP_VENDOR,
    notError:true
  })
);

export const reportsAnalyticsStockInfoThunk = createAsyncThunk(
  "reportsAnalyticsStockInfoSlice/reportsAnalyticsStockInfoThunk",
  createGraphQLThunk({
    query: GET_REPORTS_ANALYTICS_STOCK_INFO,
    getVariables: ({ inventoryReportPagination }) => ({
      inventoryReportPagination,
    }),
    responseKey: "getStockInfo",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const reportsAnalyticsProductsThunk = createAsyncThunk(
  "reportsAnalyticsProductsSlice/reportsAnalyticsProductsThunk",
  createGraphQLThunk({
    query: GET_REPORTS_ANALYTICS_PRODUCTS,
    getVariables: ({ inventoryReportPagination }) => ({
      inventoryReportPagination,
    }),
    responseKey: "getAllProducts",
    url: process.env.REACT_APP_VENDOR,
  })
);
